<template>
  <div>
    <WlCompany />
  </div>
</template>

<script>
// 获取接口地址
import WlCompany from '../components/wlCompany/wlCompany.vue'

export default {
  name: 'Wldw',
  components: {
    // sideMenu,
    // Header,
    WlCompany
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
